/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import { Text, Button } from '@gasbuddy/react-components';
import Modal from '../../modal';
import styles from './styles.css';
import sharedStyles from '../../../styles/shared.css';

const { gTagEvent } = require('../../../../lib/global-site-tag').default;

const BLOG_URL = 'https://www.gasbuddy.com/go/7-ways-retailers-can-get-the-most-out-of-customer-reviews-2';

const HowToRespondButton = () => {
  const handleOnLinkClick = () => {
    gTagEvent('Reply Review Help Popup', 'Clicked CHECK OUT OUR BLOG FOR MORE TIPS');
    window.open(BLOG_URL, '_blank');
  };

  return (
    <Modal
      title="Get the most out of responding to reviews"
      button={(
        <img
          className={styles.helpIcon}
          src="/images/stationProfile/v2/review/help-with-circle.svg"
          alt="How to respond"
        />
    )}
      hideHeaderSeparator
      size="sm"
      gTagTitle="Reply Review Help Popup"
      ctaButtons={[
        <Button
          className={sharedStyles.linkButton}
          type="button"
          link
        // eslint-disable-next-line no-alert
          onClick={handleOnLinkClick}
        >
        CHECK OUT OUR BLOG FOR MORE TIPS
        </Button>,
      ]}
    >
      <br />
      <Text className={sharedStyles.headerText} centered>
      LISTEN
      </Text>
      <br />
      <Text className={sharedStyles.secondaryText} centered>
      Your customers define your brand based on their experiences at your stations.
      Spend some time reading what they are saying and looking for common themes in their reviews.
      </Text>
      <br />
      <br />
      <Text className={sharedStyles.headerText} centered>
      SORT THROUGH THE NOISE
      </Text>
      <br />
      <Text className={sharedStyles.secondaryText} centered>
      Filter your reviews by date, and tackle the most recent to quickly triage any negative reviews with a response.
      Start with something specific by searching for keywords such as “coffee,” “service,” or “clean” to gain insight
      into how customers are talking about your brand.
      </Text>
      <br />
      <br />
      <Text className={sharedStyles.headerText} centered>
      TURN AN UNHAPPY CUSTOMER INTO YOUR #1 FAN
      </Text>
      <br />
      <Text className={sharedStyles.secondaryText} centered>
      You have the opportunity to win back a dissatisfied customer with a courteous, personal response to a negative review.
      If possible, go the extra mile and offer a special incentive to get them back into your store.
      </Text>
      <br />
    </Modal>
  );
};

export default HowToRespondButton;
